export function getItemTotalAmount(item) {
  let subtotal2 = 0;
  let quantity = item.quantity;
  // console.log("item_____________________________________________  ", item)
  // let unitPrice = item.unitPrice;
  let unitPrice =
    parseFloat(item.exchanged_rate) ||
    parseFloat(item.unitPrice) ||
    parseFloat(item.rate);

  let discountType = item.discountType || item.discount_type || 'percent';
  let discount = item.exchanged_discount_item_level || item.discount || 0;
  let total = (quantity * unitPrice)?.toFixed(2);
  // console.log('name -- ', item.item_name || item.name);
  // console.log(
  //   'exchanged_amount_without_tax_and_discount -- ',
  //   total
  // );

  if (discountType === 'percent') {
    if (discount > 100) {
      return 0;
    }
    let totalDiscount = (total * discount) / 100;
    subtotal2 += parseFloat(total - totalDiscount);
    // console.log('exchangedItemDiscount  -- ', totalDiscount);
    // console.log('subtotal2  -- ', subtotal2);
    // console.log("====================================");

    return parseFloat(total - totalDiscount) || 0;
  } else if (discountType === 'amount') {
    if (discount > total) {
      return 0;
    }
    return parseFloat(total - discount) || 0;
  } else return parseFloat(total) || 0;
}
